import { SessionStore } from '../../constants';
import { WorkflowItem } from '../../store/interfaces';
import { ResponseReuseType, TaskItemStatus } from '../../taskList/constants';
import { Stage, TaskItem } from '../../taskList/interfaces';
import { FORMS } from '../constants/constants';
import { checkFormsCompleted } from './checkFormsCompleted';

export const filterStageList = (stageList: Stage[], workflowItem: WorkflowItem): Stage[] => {
  if (workflowItem) {
    const config = JSON.parse(workflowItem.configuration);
    return stageList.map((stage: Stage) => {
      const newStage = config.configWidgetJSON.tasks.find((task: Stage) => task.id === stage.id);
      if (newStage) {
        const items = stage.items.map((item) => {
          const newItem = newStage.items.find((taskItem: TaskItem) => taskItem.id === item.id);
          if (newItem) return newItem;
          return item;
        });
        newStage['items'] = items;
        return { ...newStage, responseReuseType: null };
      }
      return { ...stage, responseReuseType: null };
    });
  }

  return stageList;
};

export const stageListMapper = (data: Stage[]): Stage[] => {
  let completedIndex: number;
  let completionIndicator: number;
  return data.map((stage, index) => {
    const items = checkFormsCompleted(stage.items);
    const isStageCompleted = items.every((item) => item.status === TaskItemStatus.COMPLETED);
    let anyItemIsActive = false;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.status === TaskItemStatus.COMPLETED || anyItemIsActive) {
        item.isActive = false;
      } else if (
        item.status === TaskItemStatus.IN_PROGRESS ||
        !item.status ||
        item.status === TaskItemStatus.NOT_STARTED
      ) {
        item.isActive = true;
        anyItemIsActive = true;
      }
    }
    const projectSettingsString = sessionStorage.getItem(SessionStore.projectSettings);
    const projectSettings = projectSettingsString && JSON.parse(projectSettingsString);

    if (isStageCompleted) {
      stage.status = TaskItemStatus.COMPLETED;
      completedIndex = index;
    } else {
      completionIndicator = completionIndicator ? completionIndicator : index;
    }
    if (index !== 0) {
      // need to simplify this condition
      const locked = !(isStageCompleted || index === completedIndex + 1) || index > completionIndicator;
      completedIndex =
        completedIndex || (data.length && data[0].title.toString().toUpperCase() !== FORMS) ? completedIndex : 0;
      const hideStage = !projectSettings.showSubsequentStages && !(isStageCompleted || index === completedIndex + 1);

      return {
        ...stage,
        items: items,
        locked: isStageCompleted ? false : locked,
        completed: isStageCompleted,
        visibility: !hideStage,
        isActive: !locked && !isStageCompleted,
      };
    }
    return {
      ...stage,
      items: items,
      locked: false,
      completed: isStageCompleted,
      isActive: !isStageCompleted,
    };
  });
};

/** check if frr applied on all stages */
export const isFrrAppliedOnAllStages = (stages: Stage[]): boolean => {
  let frrAppliedOnAllStages = false;
  for (const stage of stages) {
    if (stage?.title?.toString().toUpperCase() !== FORMS) {
      if (
        (stage?.responseReuseType === ResponseReuseType.FULL_RR ||
          stage?.responseReuseType === ResponseReuseType.PARTIAL_RR) &&
        (stage.completed || stage.status === TaskItemStatus.COMPLETED)
      )
        frrAppliedOnAllStages = true;
      else {
        frrAppliedOnAllStages = false;
        break;
      }
    }
  }

  return frrAppliedOnAllStages;
};
